// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uJBnImfbcTFN49 {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.LNgD2KC5Owb6qw {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.pa9lm3jrSFuNi3 {
  padding: var(--ds-space-400, 32px) 140px var(--ds-space-500, 40px) 140px;
  text-align: center;
}
.bAn09qtHrPHc9G {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.JOqP_2CXcRatjU {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.JOqP_2CXcRatjU:hover,
.JOqP_2CXcRatjU:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaAnnouncementModal = `uJBnImfbcTFN49`;
export var headingImage = `LNgD2KC5Owb6qw`;
export var contentContainer = `pa9lm3jrSFuNi3`;
export var ctasContainer = `bAn09qtHrPHc9G`;
export var closeButton = `JOqP_2CXcRatjU`;
export default ___CSS_LOADER_EXPORT___;
